/**
 * Picks v2 (redesigned shell) or v1 (legacy MUI sidebar) based on the redesign
 * flag. Same pattern as SessionsPageSwitch / LoginSwitch — single entry point
 * in routes.js, lets QA flip implementations from the floating DevTools.
 */
import React from 'react';
import { useRedesignFlag } from '../utils/redesignFlag';
import AuthLayout   from './authLayout';
import AuthLayoutV2 from './authLayoutV2';

export default function AuthLayoutSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? AuthLayoutV2 : AuthLayout;
  return <Component {...props} />;
}
